// import pro1 from "../../assets/project1.png"
import heathcare from "../../assets/healthcare.png"
import shopping from "../../assets/shopping.png"
// import pro2 from "../../assets/project2.png"
// import pro3 from "../../assets/project3.png"



export const WorkCardData = [

    {
        imgsrc : heathcare,
        title : "End to end Health care platform",
        text : "I led the development of a groundbreaking healthcare platform as a Fullstack Python Developer, integrating microservices for Doctors, Patients, Pharmacies, and Phlebotomists. Employing AWS services like EKS, Terraform, and Ansible, I orchestrated seamless CI/CD pipelines, ensuring rapid deployment. The platform, enriched with React.js and Django, boasts a user-friendly interface. Advanced features, including telehealth and data pipelines with Apache Airflow, improve patient care. My role included rigorous testing, code reviews, and an Agile approach, resulting in a cutting-edge solution that enhances efficiency, security, and accessibility in healthcare operations"
        ,
        view : "https://www.youtube.com/"
    },
    {
        imgsrc : shopping,
        title : "Solution for Commercial Website",
        text : "This commercial website solution leverages microservices (Django, Flask, FastAPI) for seamless product catalog, user management, and order processing. Deployed on Kubernetes with CI/CD pipelines and an API gateway, it ensures scalability and reliability. Apache Airflow orchestrates data pipelines, optimizing ETL processes. Ansible automates infrastructure, enhancing efficiency. Robust security measures, monitoring tools, and payment integrations are in place. The responsive UI, coupled with iterative development and user feedback loops, creates a dynamic, user-friendly experience. This comprehensive approach blends cutting-edge technologies to deliver a secure, efficient, and continuously improving e-commerce platform for grains, ready-to-eat foods, fruits, and vegetables."
        ,
        view : "https://www.youtube.com/"
    },
    // {
    //     imgsrc : heathcare,
    //     title : "End to end Health care platform",
    //     text : "I led the development of a groundbreaking healthcare platform as a Fullstack Python Developer, integrating microservices for Doctors, Patients, Pharmacies, and Phlebotomists. Employing AWS services like EKS, Terraform, and Ansible, I orchestrated seamless CI/CD pipelines, ensuring rapid deployment. The platform, enriched with React.js and Django, boasts a user-friendly interface. Advanced features, including telehealth and data pipelines with Apache Airflow, improve patient care. My role included rigorous testing, code reviews, and an Agile approach, resulting in a cutting-edge solution that enhances efficiency, security, and accessibility in healthcare operations"
    //     ,
    //     view : "https://www.youtube.com/"
    // },
    
    // {
    //     imgsrc : pro2,
    //     title : "LMS Website Design",
    //     text : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum"
    //     ,
    //     view : "https://www.youtube.com/"
    // },

    // {
    //     imgsrc : pro3,
    //     title : "Rymo Website Design",
    //     text : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum"
    //     ,
    //     view : "https://www.youtube.com/"
    // }

];


